
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProvisioningStep } from '@/enums/SmoothrPay';
import { MerchantConfiguration } from '@/interfaces/models/SmoothrPay';
import { canRunStep, isStepComplete, PROVISIONING_STEPS } from '@/util/smoothrPay';

/**
 * The Adyen provisioning sequence. Which step may run is derived from the
 * configuration document itself, so a half-provisioned merchant resumes
 * correctly after a reload or a failed step.
 */
@Component
export default class ProvisioningSteps extends Vue {
  @Prop({ type: Object, required: true }) public configuration!: MerchantConfiguration;
  @Prop({ type: Boolean, default: false }) public canManage!: boolean;
  /** The step currently running, so only its button spins. */
  @Prop({ type: String, default: '' }) public busy!: string;

  get steps(): ProvisioningStep[] {
    return PROVISIONING_STEPS;
  }

  public isComplete(step: ProvisioningStep): boolean {
    return isStepComplete(this.configuration, step);
  }

  public canRun(step: ProvisioningStep): boolean {
    return canRunStep(this.configuration, step);
  }
}
